module.exports = __webpack_public_path__ + "static/img/teacher-icon.964566c2.svg";